import { swrCommonOnErrorHandler, useErrorAlertContext } from 'lib/ErrorAlert';
import { PropsWithChildren } from 'react';
import { SWRConfig } from 'swr';

const getErrorStatus = (err: unknown): number | undefined =>
  (err as { response?: { status?: number } } | null | undefined)?.response?.status;

const getRequestUrl = (err: unknown): string | undefined =>
  (err as { config?: { url?: string } } | null | undefined)?.config?.url;

export const SWRConfigProvider = ({ children }: PropsWithChildren) => {
  const { addError } = useErrorAlertContext();

  return (
    <SWRConfig
      value={{
        shouldRetryOnError: false,
        onError: async (err) => {
          // 5/29 MTG 決定: 以下のステータスは画面側で inline 処理する前提なので
          // グローバルスナックバーには出さない (赤+白の二重表示を回避)。
          //   404: 「該当なし = 未登録 / 利用可能」
          //   409: 「他のユニットで使用中」等のコンフリクト
          const status = getErrorStatus(err);
          if (status === 404 || status === 409) return;
          if (getRequestUrl(err)?.endsWith('/auth/token')) return;
          swrCommonOnErrorHandler({ err, addError });
        },
      }}
    >
      {children}
    </SWRConfig>
  );
};
